import { DatePicker } from "antd";
import dayjs from "dayjs";
import "dayjs/locale/th";
import buddhistEra from "dayjs/plugin/buddhistEra";
import thBEPicker from "../utils/locale/th_BE_picker"; // ที่ตั้ง yearFormat = 'BBBB'

dayjs.locale("th");
dayjs.extend(buddhistEra);

const toThaiDigits = (s) => s.replace(/\d/g, (d) => "๐๑๒๓๔๕๖๗๘๙"[d]);

function formatThaiBE(value, { thaiDigits = false, longMonth = false } = {}) {
  if (!value) return "";
  const d = value.locale("th");
  const dd = d.format("DD");
  const month = d.format(longMonth ? "MMMM" : "MMM"); // ก.พ. / กุมภาพันธ์
  const yearBE = d.year() + 543; // แสดงปี พ.ศ.
  let str = `${dd} ${month} ${yearBE}`;
  return thaiDigits ? toThaiDigits(str) : str;
}
// ====== Helpers (ใช้ร่วมกับของเดิม) ======
const formatThaiMonthBE = (value, { thaiDigits = false } = {}) => {
  if (!value) return "";
  const d = value.locale("th");
  const month = d.format("MMMM"); // ชื่อเดือนเต็ม
  const yearBE = d.year() + 543;
  const str = `${month} ${yearBE}`;
  return thaiDigits ? toThaiDigits(str) : str;
};

// ====== Month Picker (เดี่ยว) : เลือกแค่เดือน+ปี ======
export function ThaiMonthPicker({
  value,
  onChange,
  thaiDigits = false,
  inputReadOnly = true,
  placeholder = "เลือกเดือน (พ.ศ.)",
  normalizeToStartOfMonth = false, // true = คืนค่าเป็นวันแรกของเดือน
  ...props
}) {
  // ถ้าต้องการ normalize ค่าออกให้เป็นวันแรกของเดือน
  const handleChange = (val) => {
    if (!val) return onChange?.(val, "");
    const v = normalizeToStartOfMonth ? val.startOf("month") : val;
    onChange?.(v, formatThaiMonthBE(v, { thaiDigits }));
  };

  return (
    <DatePicker
      picker="month"
      locale={thBEPicker}
      value={value}
      onChange={handleChange}
      format={(v) => formatThaiMonthBE(v, { thaiDigits })}
      placeholder={placeholder}
      allowClear
      inputReadOnly={inputReadOnly}
      {...props}
    />
  );
}

export default function ThaiDatePicker({
  value,
  onChange,
  thaiDigits = false, // true = แปลงเลขเป็น ๐-๙
  longMonth = false, // true = ชื่อเดือนเต็ม
  inputReadOnly = true, // ป้องกันพิมพ์ค่า BE เองแล้ว parse เพี้ยน
  placeholder = "เลือกวันที่ (พ.ศ.)",
  ...props
}) {
  return (
    <DatePicker
      locale={thBEPicker} // ✅ ใส่ locale
      value={value}
      onChange={onChange}
      format={(v) => formatThaiBE(v, { thaiDigits, longMonth })}
      placeholder={placeholder}
      allowClear
      inputReadOnly={inputReadOnly}
      {...props}
    />
  );
}

export function ThaiRangePicker({
  value,
  onChange,
  thaiDigits = false,
  longMonth = false,
  inputReadOnly = true,
  placeholder = ["วันที่เริ่ม (พ.ศ.)", "วันที่สิ้นสุด (พ.ศ.)"],
  ...props
}) {
  const { RangePicker } = DatePicker;
  return (
    <RangePicker
      locale={thBEPicker} // ✅ ใส่ locale
      value={value}
      onChange={onChange}
      format={(v) => formatThaiBE(v, { thaiDigits, longMonth })}
      placeholder={placeholder}
      allowClear
      inputReadOnly={inputReadOnly}
      {...props}
    />
  );
}
